module.exports = __webpack_public_path__ + "static/media/error404mobile.c12671a2.png";